export default "__VITE_ASSET__7178d365__"